import styled from "styled-components";
import { BORDER_RADIUS, COLORS, FONT_SIZE, FONT_WEIGHT } from "constants/variables";

export const ShelterOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px;
  @media (max-width: 650px) { align-items: flex-end; justify-content: center; padding: 12px; }
`;
export const ShelterPanel = styled.div`
  width: 480px;
  max-width: 100%;
  max-height: calc(100dvh - 48px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 24px 32px 32px;
  background: ${COLORS.Cultured};
  color: ${COLORS.RaisinBlack};
  border: 1px solid ${COLORS.lineColor};
  border-radius: ${BORDER_RADIUS.radius32};
  box-shadow: 0 12px 48px ${COLORS.boxShadow};
  @media (max-width: 650px) {
    padding: 20px 24px 24px;
    max-height: calc(100dvh - 24px);
  }
  @media (max-width: 360px) { padding: 16px 20px 20px; }
`;
export const ShelterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  span { font-size: ${FONT_SIZE.fix14}; font-weight: ${FONT_WEIGHT.bold}; letter-spacing: 0.04em; }
`;
export const ShelterClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  margin-right: -10px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: ${COLORS.RaisinBlack};
  cursor: pointer;
  &:hover { background: ${COLORS.Background}; }
  &:focus-visible { outline: 3px solid ${COLORS.Crimson}; outline-offset: 2px; }
`;
export const ShelterTitle = styled.h2`
  margin: 0;
  font-size: ${FONT_SIZE.max32};
  font-weight: ${FONT_WEIGHT.bold};
  line-height: 1.25;
  overflow-wrap: anywhere;
  &::after { content: ""; display: block; width: 40px; height: 4px; background: ${COLORS.Crimson}; margin-top: 12px; }
`;
export const ShelterNavigation = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 48px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: ${BORDER_RADIUS.radius32};
  background: ${COLORS.VividAuburn};
  color: ${COLORS.Cultured};
  font-size: ${FONT_SIZE.fix16};
  font-weight: ${FONT_WEIGHT.semiBold};
  text-decoration: none;
  transition: background 150ms ease;
  &:hover { background: ${COLORS.FaluRed}; }
  &:focus-visible { outline: 3px solid ${COLORS.Crimson}; outline-offset: 4px; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;
